<div class="d-inline-flex">
  <ncp-button
    #addInsuranceButton
    [options]="btnInsOptions()"
  >
    <i
      class="bi bi-shield-check healthIcon"
    >
    </i>
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="contacts_form"
      name="contacts_form"
      [formGroup]="form"
      #insFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-input #name [(options)]="nameInputOptions" />
      <ncp-input #number [(options)]="numberInputOptions" />
    </form>
  </ncp-modal>
</div>
